import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Button,
  Link as MuiLink,
} from '@mui/material';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
import { toast, ToastContainer } from 'react-toastify';

export function Reset() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [email, setEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [validToken, setValidToken] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      axiosInstance
        .post('/users/reset/verify', { token })
        .then(response => setValidToken(response.success))
        .catch(() => setValidToken(false));
    }
  }, [token]);

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axiosInstance.post('/users/reset', { email });
      if (response.success) {
        toast.success(response.message || 'Email enviado');
        setResetSent(true);
      }
    } catch (error) {
      toast.error(error.message || 'Error al enviar email');
    }
    setLoading(false);
  }

  async function updatePassword(event) {
    event.preventDefault();
    if (newPassword !== confirmNewPassword) return;
    setLoading(true);
    try {
      const response = await axiosInstance.put('/users/reset/new', {
        token,
        password: newPassword,
      });
      if (response.success) {
        toast.success(response.message || 'Contraseña actualizada');
        setTimeout(() => navigate('/'), 2000);
      }
    } catch (error) {
      toast.error(error.message || 'Error al actualizar contraseña');
      console.error(error);
    }
    setLoading(false);
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f4f6f8',
        padding: 2,
      }}
    >
      <ToastContainer />
      <Card sx={{ width: 400, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" textAlign="center" gutterBottom>
            {token ? 'Restablecer Contraseña' : 'Recuperar Contraseña'}
          </Typography>
          <Box
            component="form"
            onSubmit={token ? updatePassword : handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            {!token && !resetSent && (
              <TextField
                label="Correo Electrónico"
                type="email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            )}
            {!token && resetSent && (
              <Typography textAlign="center" color="green">
                ✅ Revisa tu correo para el enlace de recuperación.
              </Typography>
            )}
            {token && validToken && (
              <>
                <TextField
                  label="Nueva Contraseña"
                  type="password"
                  variant="outlined"
                  fullWidth
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                />
                <TextField
                  label="Confirmar Nueva Contraseña"
                  type="password"
                  variant="outlined"
                  fullWidth
                  value={confirmNewPassword}
                  onChange={e => setConfirmNewPassword(e.target.value)}
                />
              </>
            )}
            {token && !validToken && (
              <Typography textAlign="center" color="red">
                ❌ El enlace de recuperación es inválido o ha expirado.
              </Typography>
            )}
            {!resetSent && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 1 }}
                disabled={loading}
              >
                {token
                  ? 'Actualizar Contraseña'
                  : 'Enviar Enlace de Recuperación'}
              </Button>
            )}
          </Box>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
          <MuiLink
            component={Link}
            to="/"
            underline="none"
            variant="body2"
            color="primary"
          >
            Cancelar
          </MuiLink>
        </CardActions>
      </Card>
    </Box>
  );
}

export default Reset;
